const defaultLocale = "en-GB"; // 'en', 'en-US', 'en-GB', 'id'

const defaultLocaleOptions = {
  day: "numeric",
  month: "short",
  year: "numeric",
} as Intl.DateTimeFormatOptions;

/**
 * Convert a Date object to string with specified locale format.
 */
export const formatDate = (
  date: Date | string,
  locale = defaultLocale,
  localeOptions = defaultLocaleOptions
) => {
  if (typeof date == "string") {
    return new Date(date).toLocaleDateString(locale, localeOptions);
  } else if (typeof date == "object") {
    return date.toLocaleDateString(locale, localeOptions);
  }
  return "";
};

/**
 * Calculate if a given date is > x days from now.
 */
export const checkIfOld = (date: Date | string, maxDayDiff = 1095) => {
  const today = new Date().getTime();
  const olderDay = new Date(date).getTime();

  const diff = today - olderDay;
  const dayDiff = diff / 24 / 60 / 60 / 1000;
  return dayDiff > maxDayDiff;
};
